import { useState } from "react";
import { Link } from "react-router-dom";
import { cities94 } from "@/mocks/cities94";

const GMB_URL = "https://maps.app.goo.gl/kadTYV8afmpfdVSu8";

export default function ZonesSection() {
  const [showAll, setShowAll] = useState(false);
  const displayed = showAll ? cities94 : cities94.slice(0, 18);

  return (
    <section id="zones" className="py-20 md:py-28 bg-[#F8F8F8] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#FFB100] text-black text-xs font-black px-3 py-1.5 rounded-full mb-4 uppercase tracking-widest">
              <i className="ri-map-pin-line"></i>
              94 — Val-de-Marne
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-black uppercase leading-tight mb-3">
              Intervention Rapide
              <br />
              <span className="text-[#FFB100]">Dans Tout le Val-de-Marne</span>
            </h2>
            <p className="text-gray-500 text-base max-w-xl">
              Securycles intervient dans toutes les communes du 94. Serrurier disponible 24h/24 et 7j/7 pour toute urgence serrurerie.
            </p>
          </div>
          <a
            href={GMB_URL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 border-2 border-black text-black font-bold text-sm px-5 py-3 rounded-full hover:bg-black hover:text-white transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            <i className="ri-map-2-line"></i>
            Voir sur Google Maps
          </a>
        </div>

        {/* Cities grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {displayed.map((city) => (
            <Link
              key={city.slug}
              to={`/serrurier/${city.slug}`}
              className="bg-white rounded-xl p-4 border border-gray-100 hover:border-[#FFB100] hover:-translate-y-0.5 transition-all duration-200 group cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center bg-[#FFB100]/10 rounded-lg mb-2 group-hover:bg-[#FFB100] transition-colors">
                <i className="ri-map-pin-2-line text-[#FFB100] text-sm group-hover:text-black transition-colors"></i>
              </div>
              <p className="font-bold text-black text-xs leading-tight mb-0.5">{city.name}</p>
              <p className="text-gray-400 text-xs">{city.zip}</p>
              <p className="text-[#FFB100] text-xs font-semibold mt-1">{city.time}</p>
            </Link>
          ))}
        </div>

        {/* Show more */}
        {!showAll && (
          <div className="mt-8 text-center">
            <button
              onClick={() => setShowAll(true)}
              className="inline-flex items-center gap-2 text-black font-bold text-sm border-2 border-[#FFB100] px-6 py-3 rounded-full hover:bg-[#FFB100] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-down-line"></i>
              Voir toutes les villes
            </button>
          </div>
        )}

        {/* Map embed */}
        <div className="mt-12 rounded-2xl overflow-hidden border border-gray-200 h-72 md:h-96">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d42048.12345678!2d2.4567!3d48.7890!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e60d6b3b3b3b3b%3A0x3b3b3b3b3b3b3b3b!2sCr%C3%A9teil%2C%20France!5e0!3m2!1sfr!2sfr!4v1234567890"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Zone d'intervention Securycles - Serrurier Créteil Val-de-Marne"
          ></iframe>
        </div>

        {/* Stripe décorative */}
        <div className="mt-12 rounded-2xl overflow-hidden h-12 flex">
          {Array.from({ length: 20 }).map((_, i) => (
            <div
              key={i}
              className="flex-1 h-full"
              style={{
                background: i % 2 === 0 ? "#FFB100" : "#000000",
                transform: "skewX(-15deg)",
                marginLeft: i === 0 ? "-10px" : undefined,
              }}
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
}
